export default __webpack_public_path__ + "static/media/report-pic1.c7eecd52.jpg";